import {Component, Input, OnChanges} from "@angular/core";
import {Option} from "./option";

@Component({
    selector: "woa-option",
    template: ""
})
export class OptionComponent implements OnChanges {
    @Input() label: string;
    @Input() value: any;

    private _option: Option;

    ngOnChanges(): void {
        this._option = new Option(this.label, this.value);
    }

    public get option(): Option {
        return this._option;
    }
}



// WEBPACK FOOTER //
// ./src/app/inputs/selection-field/option.component.ts